<template>
  <v-card
    v-if="
      (activeTextConfig && activeTextConfig.text) ||
      (config && config.background && config.background.color) ||
      (config && config.background && config.background.gradient) ||
      (config && config.image && config.image.url)
    "
    elevation="1"
    class="rounded-lg pgm-dashboard-container headline-container d-flex align-center"
    :class="backgroundClass"
    :style="backgroundStyle"
  >
    <!-- <img
      v-if="config && config.image && config.image.url"
      class="rounded dashboard-image"
      :src="config.image.url"
    /> -->
    <div
      v-if="activeTextConfig && activeTextConfig.text"
      class="overlay-text"
      :style="overlayTextStyle"
      :class="overlayTextClass"
    >
      <span>
        {{ activeTextConfig.text }}
      </span>
    </div>
  </v-card>
</template>
<script>
export default {
  name: "Headline",
  props: {
    config: {
      type: Object,
      required: true,

      // Developer note:
      // This schema is for readability - it doesn't actually restrict anything on the Vue side
      image: {
        type: Object,
        required: false,
        url: {
          type: String,
          required: true,
        },
      },
      background: {
        type: Object,
        required: false,
        color: {
          type: String,
          required: false,
        },
        gradient: {
          type: String,
          required: false,
        },
      },
      overlay: {
        type: Object,
        required: false,
        text: {
          type: String,
          required: true,
        },
        color: {
          type: String,
          required: false,
          default: "black",
        },
        horizontalAlignment: {
          type: String,
          required: false,
          default: "left",
          //   start, center, end
        },
        verticalAlignment: {
          type: String,
          required: false,
          default: "top",
          //   start, center, end
        },
      },
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    activeTextConfig() {
      const overlay = this.config && this.config.overlay;
      const title = this.config && this.config.title;
      return overlay != null ? overlay : title != null ? title : null;
    },
    backgroundStyle() {
      let style = {};

      if (this.config?.background?.color) {
        style["background-color"] = this.config?.background?.color;
      } else if (this.config?.background?.gradient) {
        style["background"] = this.config?.background?.gradient;
      } else if (this.config?.image?.url) {
        style["background-image"] = `url(${this.config?.image?.url})`;
        style["background-size"] = "cover";
        style["background-position"] = "center";
        style["background-repeat"] = "no-repeat";
      }

      return style;
    },
    backgroundClass() {
      let classList = ``;
      // classList += ` dashboard-image-${this.config?.image?.url ? "true" : "false"}`;
      return classList;
    },
    overlayTextStyle() {
      let style = {
        color: (this.activeTextConfig && this.activeTextConfig.color) || "black",
      };

      return style;
    },
    overlayTextClass() {
      let classList = "d-flex full-width full-height pa-5";
      classList += ` pgm-dashboard-text-${
        (this.activeTextConfig && this.activeTextConfig.size) || "md"
      } align-${
        (this.activeTextConfig && this.activeTextConfig.verticalAlignment) || "start"
      } justify-${(this.activeTextConfig && this.activeTextConfig.horizontalAlignment) || "start"}`;

      if (this.activeTextConfig && this.activeTextConfig.bold) {
        classList += " font-weight-bold";
      }
      if (this.activeTextConfig && this.activeTextConfig.italic) {
        classList += " font-italic";
      }
      if (this.activeTextConfig && this.activeTextConfig.underline) {
        classList += " text-decoration-underline";
      }

      return classList;
    },
  },
};
</script>
<style scoped>
.headline-container {
  aspect-ratio: 10 / 1;
  width: 100%;
  height: auto;
}

.dashboard-image {
  aspect-ratio: 10 / 1;
  object-fit: fill;
  width: 100%;
  height: auto;
}

.overlay-text {
  position: relative;
}
/* 
@media only screen and (max-width: 600px) {
  .headline-container {
    aspect-ratio: 4 / 1;
  }
} */
</style>
